import { useSelector } from 'react-redux'
import { DashboardTypes } from 'features/Codes'

export const DashboardTypeNames = {
  [DashboardTypes.CAMPAIGN]: '캠페인',
  [DashboardTypes.AD_GROUP]: '광고그룹',
  [DashboardTypes.KEYWORD]: '키워드',
  [DashboardTypes.CREATIVE]: '소재',
}
export const useDashboardTypeName = () => {
  const { type } = useSelector(state => state.dashboard.common)
  return { type, name: DashboardTypeNames[type] }
}
